import { RequestModel } from '@core/models';

export function leaseProductIconResolver(
  carType?: RequestModel['carType'],
  carModel?: RequestModel['carModel'],
): string {
  if (!carType && !carModel) return 'x-icon-lp::other';

  const cp = carType?.toLowerCase();
  const cm = carModel?.toLowerCase();

  const keywordToIconMap: { [keyword: string]: string } = {
    грузовой: 'x-icon-lp::heavy',
    коммерческий: 'x-icon-lp::heavy',
    рефрижератор: 'x-icon-lp::heavy',
    самосвал: 'x-icon-lp::heavy',
    полуприцеп: 'x-icon-lp::heavy',
    прицеп: 'x-icon-lp::heavy',
    тягач: 'x-icon-lp::heavy',
    мусоровоз: 'x-icon-lp::heavy',
    фургон: 'x-icon-lp::heavy',
    легковой: 'x-icon-lp::light',
    личный: 'x-icon-lp::light',
    каршеринг: 'x-icon-lp::light',
    такси: 'x-icon-lp::light',
    спец: 'x-icon-lp::special',
    автокран: 'x-icon-lp::special',
    бетоносмеситель: 'x-icon-lp::special',
    каток: 'x-icon-lp::special',
    комбайн: 'x-icon-lp::special',
    погрузчик: 'x-icon-lp::special',
    трактор: 'x-icon-lp::special',
    экскаватор: 'x-icon-lp::special',
    самоход: 'x-icon-lp::special',
    автобус: 'x-icon-lp::passenger',
    микроавтобус: 'x-icon-lp::passenger',
    пассажирский: 'x-icon-lp::passenger',
    оборудование: 'x-icon-lp::property',
    контейнер: 'x-icon-lp::property',
  };

  for (const keyword in keywordToIconMap) {
    if (cp?.includes(keyword)) {
      return keywordToIconMap[keyword];
    } else if (cm?.includes(keyword)) {
      return keywordToIconMap[keyword];
    }
  }

  return 'x-icon-lp::other';
}
